import { render, staticRenderFns } from "./DiscountIndex.vue?vue&type=template&id=6e6bd8aa"
import script from "./DiscountIndex.vue?vue&type=script&lang=js"
export * from "./DiscountIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports